<template>
  <footer>
    <div class="container">
      <img class="logo" src="./../assets/xplora-logo.png">
      <span class="logo-title">JUST EXPERIENCE</span>
      <div class="social">
        <a href="https://business.facebook.com/Xplora-Smartwatch-1058890300877508/?business_id=928708293845956" target="_blank">
          <img src="./../assets/facebook_icon.png">
        </a>
        <a href="https://www.instagram.com/myxplorauk/" target="_blank">
          <img src="./../assets/instagram_icon.png">
        </a>
      </div>
      <div class="company-details">
        XPLORA TECHNOLOGIES LTD<span class="desktop">, </span><br />Belmont Place<span class="desktop">, </span><br />Maidenhead, UK, SL6 6TB<span class="desktop">, </span><br />REG NO: 10864147<br /><br />
      </div>
      <div class="company-links">
        <a href="/static/pdf/XPLORA_Privacy_Policy_17_04_2018.pdf" target="_blank">Privacy Policy</a><br />
        <span class="desktop">&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;</span>
        <a href="http://support.myxplora.co.uk/" target="_blank">Customer support</a><br />
        <span class="desktop">&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;</span>
        <a href="mailto:support@myxplora.co.uk" target="_blank">support@myxplora.co.uk</a>
      </div>
      <div class="copyright">
        © 2018. All Rights Reserved.
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'pageFooter',
  data () {
    return {
      
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
footer {
  width: 100%;
  float: left;
  background-color: #3c434c;
  padding: 50px 0;
}
footer .container {
  padding-left: 15px;
  padding-right: 15px;
  margin: 0 auto;
  text-align: center;
}
footer .container img.logo {
  width: 110px;
}
footer .container span.logo-title {
  color: #ef3d23;
  font-size: 16px;
  font-weight: 700;
  line-height: 64px;
  display: block;
}
footer .container .social {
  margin-bottom: 20px;
}
footer .container .social a:first-child {
  margin-right: 50px;
}

footer .container div {
  color: #fff;
  line-height: 24px;
  font-size: 18px;
}

footer .container div br {
  display: none;
}

footer .container .copyright {
  opacity: 0.5;
}

footer .container div a {
  text-decoration: none;
  color: #fff;
}

@media (max-width: 768px) {
  footer .container div br {
    display: block;
  }
  footer .container div span.desktop {
    display: none;
  }
}

@media (max-width: 520px) {
  footer {
    padding: 30px 0;
  }
  footer .container img.logo {
    width: 80px;
  }
  footer .container span.logo-title {
    line-height: 40px;
  }
  footer .container div {
    color: #fff;
    line-height: 20px;
    font-size: 16px;
  }
  footer .container .social {
    margin-bottom: 10px;
  }
  footer .container .social a:first-child {
    margin-right: 20px;
  }
  footer .container .social a img {
    width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue